import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid, { GridProps } from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { createElement, ReactElement } from 'react';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

type ConsentMediumStyleProps = {
  enableVerticalView?: boolean;
  primaryFontFamily?: string;
};

type StConsentMediumGridItemProps = Omit<GridProps, 'item' | 'xs' | 'sm' | 'md' | 'lg'> &
  Pick<ConsentMediumStyleProps, 'enableVerticalView'>;

export const StConsentMediumGridItem = ({
  enableVerticalView,
  ...props
}: StConsentMediumGridItemProps): ReactElement =>
  createElement(Grid, {
    ...props,
    item: true,
    xs: enableVerticalView ? 12 : 6,
    sm: enableVerticalView ? 12 : 6,
    md: enableVerticalView ? 12 : 3,
    lg: enableVerticalView ? 12 : 3,
  });

export const StConsentMediumFormGroup = styled(FormGroup, {
  shouldForwardProp: (prop) => prop !== 'enableVerticalView',
})<Pick<ConsentMediumStyleProps, 'enableVerticalView'>>(({ enableVerticalView }) => ({
  ...(enableVerticalView && {
    width: '100%',
    flexDirection: 'column',
  }),
}));

export const StConsentMediumCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'enableVerticalView',
})<Pick<ConsentMediumStyleProps, 'enableVerticalView'>>(({ enableVerticalView }) => ({
  paddingInline: '0',
  ...(enableVerticalView && {
    padding: '0',
    margin: '-2px 0 0 0',
  }),
}));

export const StConsentMediumFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'enableVerticalView' && prop !== 'primaryFontFamily',
})<ConsentMediumStyleProps>(({ enableVerticalView, primaryFontFamily }) => ({
  display: 'flex',
  margin: enableVerticalView ? '0 0 10px 0' : 0,
  gap: '6px',
  color: '#444444',
  ...(enableVerticalView && {
    width: '100%',
    alignItems: 'flex-start',
  }),
  '& .MuiFormControlLabel-label': {
    fontFamily: `${primaryFontFamily || DEFAULT_PRIMARY_FONT_FAMILY}, sans-serif`,
    fontSize: '14px',
    lineHeight: '16px',
    ...(enableVerticalView && {
      flex: 1,
      minWidth: 0,
    }),
  },
}));
